import styled from 'styled-components';
import { FlexBox, StackPanel, typographyPresets } from '@agilepoint/wat-react-ux';
import { CheckboxGroupField, commonStyles, RadioGroupField } from 'common';

export const PlatformTypeWrapper = styled(StackPanel) <{ $isSelected: boolean | 'intermediate' }>`
    width: 370px;
    min-height: 224px;
    max-height: 100%;
    padding: 25px 30px 30px 30px;
    margin: 0 !important;
    box-sizing: border-box;
    border: ${({ $isSelected }) => ($isSelected ? '1px solid #F1F2F4' : 'none')};
    box-shadow: ${({ $isSelected }) => ($isSelected ? '0px 5px 15px rgba(0, 0, 0, 0.0688374)' : 'none')};
    background-color: ${({ theme: { mobileAppAccelerator: { semanticColors }, semantics }, $isSelected }) => ($isSelected ? semantics.palette.white : semanticColors.grayVariant6)}; 
    border-radius: 26px;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    ${commonStyles.boldTextLabel};
    ${commonStyles.outlineColor};

    .ap-checkmark-container {
        position: absolute;
        top: 25px;
        right: 25px;
        margin-bottom: 0px;
    }
    :hover{
        box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.0688374);
         background: ${({ theme }) => theme.semantics.palette.white};
         border: 1px solid  ${({ theme: { mobileAppAccelerator: { semanticColors } } }) => semanticColors.grayVariant5};
    }
`;

export const PlatformSelectionFields = styled(CheckboxGroupField)`
    width: auto;
    max-height: calc(100% - 97px);

    .ap-checkboxGroup-options {
        gap: 30px;
        align-items: flex-start;
    }

   .ap-checkboxGroup, .ap-checkboxGroup-options {
        height: 100%;
    }
`;

export const BuildDetailsFields = styled(RadioGroupField)`
    margin-bottom: 25px !important;
    .ap-radioGroup-options-wrapper {
        gap: 15px;
    }
    .ap-radioButton-wrapper {
        margin: 0 !important;
    }
    .ap-radioButton-label {
        ${typographyPresets.textStyles.small};
    }
`;

export const RelativePositionedFlexbox = styled(FlexBox)`
    position: relative;
    width:100%;
    .ap-helpicon-wrapper {
        position: absolute;
        right: 0px;
    }
    .ap-textbox-wrapper {
        padding:0px;
        .ap-textbox{
            padding:0 16px !important;
        }
    }
    .ap-file-upload-field {
        height: 100%;
    }
`;
